export default "assets/images/fremoire-hero-bg-2-a47ae409.svg";